export const caseInsensitiveIncludes = (arr: string[], value: string): boolean => {
  return arr.some(localArr => localArr.toLowerCase() === value.toLowerCase());
};
